import { gql } from "@apollo/client";

export const GET_LANDING_PAGE_REPORT_TABLE = gql`
  query GetLandingPageReportTable(
    $attributionMethod: String!
    $accountingMode: String!
    $attributionWindow: String!
    $level: String!
    $dateRange: JSONObject!
    $breakdownFilters: [SalesTableReportV3BreakdownsFilterInput!]
    $adQuery: LandingPageReportTableAdQueryInput
    $urlQuery: String
    $advancedSearch: JSONObject
    $metricFilters: [LandingPageReportTableMetricsFilterInput!]
    $sorting: LandingPageReportTableSortingInput
    $aggregateAll: Boolean
    $page: Int
    $perPage: Int
  ) {
    me {
      landingPageReportTable(
        attributionMethod: $attributionMethod
        accountingMode: $accountingMode
        attributionWindow: $attributionWindow
        level: $level
        dateRange: $dateRange
        breakdownFilters: $breakdownFilters
        adQuery: $adQuery
        urlQuery: $urlQuery
        advancedSearch: $advancedSearch
        metricFilters: $metricFilters
        sorting: $sorting
        aggregateAll: $aggregateAll
        page: $page
        perPage: $perPage
      ) {
        rows {
          adKey
          name
          campaignName
          adsetName
          adName
          landingPage
          metrics
        }
        page
        perPage
        total
      }
    }
  }
`;

export const GET_LANDING_PAGE_REPORT_CHART = gql`
  query GetLandingPageReportChart(
    $attributionMethod: String!
    $accountingMode: String!
    $attributionWindow: String!
    $level: String!
    $dateRange: JSONObject!
    $breakdownFilters: [SalesTableReportV3BreakdownsFilterInput!]
    $adQuery: LandingPageReportTableAdQueryInput
    $urlQuery: String
    $advancedSearch: JSONObject
    $metricFilters: [LandingPageReportTableMetricsFilterInput!]
    $selectionFilters: [String!]
    $chartView: String
  ) {
    me {
      landingPageReportChart(
        attributionMethod: $attributionMethod
        accountingMode: $accountingMode
        attributionWindow: $attributionWindow
        level: $level
        dateRange: $dateRange
        breakdownFilters: $breakdownFilters
        adQuery: $adQuery
        urlQuery: $urlQuery
        advancedSearch: $advancedSearch
        metricFilters: $metricFilters
        selectionFilters: $selectionFilters
        chartView: $chartView
      ) {
        rows {
          name
          landingPage
          metrics
        }
      }
    }
  }
`;

export const EXPORT_LANDING_PAGE_ANALYTICS_TABLE_DATA = gql`
  mutation ExportLandingPageAnalyticsTableData(
    $exportFileName: String!
    $attributionMethod: String!
    $accountingMode: String!
    $attributionWindow: String!
    $level: String!
    $dateRange: JSONObject!
    $breakdownFilters: [SalesTableReportV3BreakdownsFilterInput!]
    $adQuery: LandingPageReportTableAdQueryInput
    $urlQuery: String
    $advancedSearch: JSONObject
    $metricFilters: [LandingPageReportTableMetricsFilterInput!]
  ) {
    exportLandingPageAnalyticsTableData(
      exportFileName: $exportFileName
      attributionMethod: $attributionMethod
      accountingMode: $accountingMode
      attributionWindow: $attributionWindow
      level: $level
      dateRange: $dateRange
      breakdownFilters: $breakdownFilters
      adQuery: $adQuery
      urlQuery: $urlQuery
      advancedSearch: $advancedSearch
      metricFilters: $metricFilters
    ) {
      successMessage
    }
  }
`;
